export default {"src":"/_next/static/media/Logo.cb4522f1.svg","height":70,"width":145,"blurWidth":0,"blurHeight":0};